import classes from "./footer.module.css";
import Minntech from "../../assets/images/Minntech.svg";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const storedLang = localStorage.getItem("lang");
  let lng = storedLang ?? navigator.language;
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(lng);
  }, [lng, i18n]);

  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <div className={classes.grid}>
          <ul>
            <li>
              <a href="#">
                <img src={Minntech} alt="logo" />
              </a>
            </li>
            <li>
              Copyright &copy; 2023 by Minntech, Inc. {t("footer.copyright")}
            </li>
          </ul>
          <ul className={classes.startup}>
            <li> Startup</li>
            <li>
              <a href="#about_us"> {t("footer.about_us")}</a>
            </li>
            <li>
              <a href="#prototype"> {t("footer.prototype")}</a>
            </li>
          </ul>
          <ul>
            <li> {t("footer.contact")}</li>
            <li> 19 mayıs Kampüsü, Teknopark Atakum/Samsun</li>
            <li>
              <a href="#"> +90 552 602 76 57</a>
            </li>
            <li>
              <a href="#"> support@minntechdelivery.com</a>
            </li>
          </ul>
        </div>
        <div className={classes.logos}>
          <a href="#">
            <ion-icon class={classes.logo} name="logo-instagram"></ion-icon>
          </a>
          <a href="#">
            <ion-icon class={classes.logo} name="logo-facebook"></ion-icon>
          </a>
          <a href="#">
            <ion-icon class={classes.logo} name="logo-twitter"></ion-icon>
          </a>
          <a href="#">
            <ion-icon class={classes.logo} name="logo-linkedin"></ion-icon>
          </a>
          <a href="#">
            <ion-icon class={classes.logo} name="logo-youtube"></ion-icon>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
